import {gsap} from "gsap";
import AOS from "aos";
import prepare from "aos/src/js/helpers/prepare";
import FormStepper from "./FormStepper";
import App from "../../App/App";
import Scroller from "../../Scroller/Scroller";
import Header from "../../Header/Header";

const FormStepperAccordion = {

    init(el) {
        this.el = el;
    },

    prepare() {
        this.el.slides.each((i, el) => {
            const order = $(el).attr('order');
            this.el.tabs.filter('[order="' + order + '"]').insertBefore($(el));
        })

        this.el.footer.appendTo(this.el.slides.filter('.active').find('.content'));
    },

    onLoad() {
        this.el.footer.appendTo($(this.el.slides[0]).find('.content'));

        if (this.el.config.useRouter) {

        } else {
            this.el.active = $(this.el.slides[0]).addClass('active');
            this.el.main.find('.tab').first().addClass('active');
        }
    },

    show(nmb) {
        const tab = this.el.tabs.filter('[order="' + nmb + '"]');
        if (!this.el.config.accordionIsClosable && tab.is('.active')) return;

        this.el.current = parseInt(tab.attr('order'));
        this.el.active = this.el.slides.filter('[order="' + this.el.current + '"]');

        this.hide();
        this.scroll(tab);

        if (this.el.config.accordionIsClosable && tab.is('.active')) return;

        gsap.set(this.el.active, {height: 'auto'});
        gsap.from(this.el.active, {height: 0})

        tab.addClass('active');
        this.el.active.addClass('active');
        this.el.arrangeButtons();
    },

    hide() {
        this.el.old = this.el.slides.filter('.active');
        const tab = this.el.tabs.filter('.active');

        gsap.to(this.el.old, {height: 0});

        setTimeout(() => {
            this.el.old.removeClass('active');
            tab.removeClass('active');
        }, 100)

        setTimeout(() => {
            AOS.refresh();
        }, 610)

        this.arrangeButtons();
    },

    arrangeButtons() {
        const footer = this.el.old.find('footer');
        footer.appendTo(this.el.active.find('.content'));
    },

    scroll(tab) {
        if (App.isDesktop) return;

        const direction = this.el.old.attr('order') < this.el.active.attr('order') ? 1 : -1;
        const oldHeight = this.el.old.find('.content').outerHeight();
        const diff = direction === 1 ? oldHeight || 0 : 0;
        let y = tab.offset().top - diff;

        gsap.to(window, {
            duration: Scroller.animTime,
            scrollTo: {y: y, offsetY: Scroller.yOffset},
        });
    },

    resize() {
        gsap.set(this.el.slides, {height: 0});
        gsap.set(this.el.active, {height: ''});
        this.el.main.css({height: ''});
    }
}

export default FormStepperAccordion;